<template>
  <div class="view home" data-name="home"></div>
</template>

<script>
export default {
  name: 'home',
  components: { },
};
</script>
